import React from 'react';
import { HeroSection } from './components/HeroSection';
import { EmotionalHook } from './components/EmotionalHook';
import { PainAgitation } from './components/PainAgitation';
import { WhyOthersFail } from './components/WhyOthersFail';
import { MechanismReveal } from './components/MechanismReveal';
import { ProductIntro } from './components/ProductIntro';
import { ChapterOverview } from './components/ChapterOverview';
import { BenefitsTimeline } from './components/BenefitsTimeline';
import { AuthorityProof } from './components/AuthorityProof';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { UrgencySection } from './components/UrgencySection';
import { MainCTA } from './components/MainCTA';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-lila-suave selection:text-azul-noche" data-id="element-0">
      <HeroSection data-id="element-1" />
      <EmotionalHook data-id="element-2" />
      <PainAgitation data-id="element-3" />
      <WhyOthersFail data-id="element-4" />
      <MechanismReveal data-id="element-5" />
      <ProductIntro data-id="element-6" />
      <ChapterOverview data-id="element-7" />
      <BenefitsTimeline data-id="element-8" />
      <AuthorityProof data-id="element-9" />
      <ValueStack data-id="element-10" />
      <Guarantee data-id="element-11" />
      <UrgencySection data-id="element-12" />
      <MainCTA data-id="element-13" />
      <FAQSection data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}